export default "__VITE_ASSET__B8BYCsd8__"